import { useState } from 'react';

import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useRouteMatch } from 'react-router-dom';

import { FileUploadForm } from './FileUploadForm';
import { createTabId, createTabPanelId, TabsPanel } from './TabsPanel';
import { BreadCrumbs, StyledTabs, StyledTab, Spacer, StyledLink } from './TabsPanel.styles';
import UsersForm from '../../SettingsPanels/UsersComponents/UsersForm';

function a11yProps(index: number) {
    return {
        id: createTabId(index),
        'aria-controls': createTabPanelId(index),
        value: index
    };
}

enum AddUsersTab {
    Form,
    FileUpload
}

export const AddUsers = () => {
    const { t } = useTranslation('portal');
    const { path } = useRouteMatch();
    const pathArray = path.split('/');
    pathArray.pop();

    const previousPath = pathArray.join('/');

    const [value, setValue] = useState(AddUsersTab.Form);

    const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    return (
        <>
            <Typography variant="h1">{t('navigationTabs.users')}</Typography>
            <BreadCrumbs>
                <StyledLink to={previousPath}>{t('users.title')}</StyledLink>
                <Spacer>/</Spacer>
                <span>{t('users.actions.add-users')}</span>
            </BreadCrumbs>
            <StyledTabs value={value} onChange={handleChange} aria-label="Add users tabs">
                <StyledTab label={t('users.form')} {...a11yProps(0)} />
                <StyledTab label={t('users.fileUpload')} {...a11yProps(1)} />
            </StyledTabs>
            <TabsPanel index={0} value={value}>
                <UsersForm />
            </TabsPanel>
            <TabsPanel index={1} value={value}>
                <FileUploadForm />
            </TabsPanel>
        </>
    );
};
